<template>
  <div class="our-beliefs-education-content" id="plataforma-de-marca-nossas-crencas-educacao-transforma" data-search-anchor>
    <div class="our-beliefs-education-overlay-title-image">
      <h1 class="our-beliefs-education-image-education-title" style="margin-top: 4rem; margin-bottom: 2rem;">
        {{ ourBeliefsEducationImageTitle }}
      </h1>
      
      <p class="our-beliefs-education-image-education-text">
        {{ ourBeliefsEducationImageTitle2 }}
      </p>
    </div>

    <div
      class="our-beliefs-education-banner-image"
      :style="{ backgroundImage: `url(${ourBeliefsEducationImageSrc})` }"
    ></div>
  </div>
</template>

<script lang="ts">
import { PageStoreContract } from '@/data/store/page.store.contract'
import OurBeliefsPageMixin from '@/mixins/our-beliefs-page-mixin'
import { OurBeliefsPageStore } from '@/store/brand-plataform-page/our-beliefs-store'
import { Component, Mixins } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'

@Component({})
export default class OurBeliefsEducationSection extends Mixins(OurBeliefsPageMixin) {
  ourBeliefsPageStore: PageStoreContract = getModule(OurBeliefsPageStore, this.$store)

  get ourBeliefsEducationImageTitle(): string {
    return this.getElementText(4, 0)
  }

  get ourBeliefsEducationImageSrc(): string {
    return this.getElementMedia(4, 0)
  }

  get ourBeliefsEducationImageTitle2(): string {
    return this.getElementText(4, 1)
  }  

  async getOurBeliefsPageStore(): Promise<void> {
    await this.ourBeliefsPageStore.getDataPage()
  }

  async mounted(): Promise<void> {
    if (!this.ourBeliefsPageStore.isLoading) {
      await this.getOurBeliefsPageStore()
    }
  }
}
</script>

<style lang="scss">
.our-beliefs-education-content {
  display: grid;
  grid-template-columns: 47% 53%;
  width: 100%;
  max-width: 1032px; 
}

.our-beliefs-education-banner-image {
  margin-top: 64px;
  position: relative;
  border-radius: 12px;
  max-width: 600px;
  width: 100%;
  height: 600px;
  background-repeat: no-repeat;
  background-position: 50%;
  background-size: cover;
}

.our-beliefs-education-overlay-title-image {
  max-width: 416px;
  width: 100%;
  height: 465px;
}

.our-beliefs-education-image-education-title {
  font-size: 40px;
  font-weight: 400;
  letter-spacing: -0.01em;  
  margin: 0;
}

.our-beliefs-education-image-education-text {
  font-size: 20px;
  font-weight: 400;
  letter-spacing: -0.01em;
  line-height: 32px;  
  width: 416px;
  margin: 0;
}
</style>
